import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import { isTotadminUser } from 'utils/auth';

export function AuthGuard({ children }: { children: ReactNode }): ReactNode {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) return null;

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!isTotadminUser(user)) {
        return <Navigate to="/login" replace />;
    }

    return children;
}
